import { Building2, FlaskConical, User, TrendingUp } from "lucide-react";

const CLIENTS = [
  {
    icon: Building2,
    title: "Empresas y Grandes Corporativos",
    description:
      "Organizaciones que requieren auditorías técnicas recurrentes y un soporte legal sólido para mantener su operatividad dentro de la norma.",
  },
  {
    icon: FlaskConical,
    title: "Instituciones Científicas y Técnicas",
    description:
      "Entidades que buscan consultoría profesional especializada para la gestión de proyectos, patentes o administración de recursos complejos.",
  },
  {
    icon: User,
    title: "Profesionales Independientes y Emprendedores",
    description:
      "Individuos que necesitan una base contable y legal impecable para escalar sus negocios con seguridad y cumplimiento total.",
  },
  {
    icon: TrendingUp,
    title: "Inversionistas y Patrimoniales",
    description:
      "Personas que demandan estrategias de protección de activos y una administración fiscal eficiente para sus diversos portafolios de inversión.",
  },
];

export default function Clientes() {
  return (
    <section
      id="clientes"
      data-testid="clients-section"
      className="relative py-24 lg:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-10 mb-16">
          <div className="lg:col-span-5">
            <div className="reveal eyebrow mb-5">Nuestros Clientes</div>
            <h2 className="reveal font-serif-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-neutral-950">
              Acompañamos a quienes{" "}
              <span className="italic text-[#E97906]">exigen</span> precisión.
            </h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7 reveal">
            <p className="text-neutral-600 text-base lg:text-[17px] leading-relaxed">
              Sagitta atiende a perfiles que valoran la rectitud, la
              confidencialidad y la atención directa de socios expertos. Cada
              relación profesional se construye sobre el principio de la
              nobleza de servicio.
            </p>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 gap-px bg-neutral-200 border border-neutral-200">
          {CLIENTS.map((c, i) => {
            const Icon = c.icon;
            return (
              <div
                key={c.title}
                data-testid={`client-${i}`}
                className="reveal group relative bg-white p-8 lg:p-12 hover:bg-[#FFF7F0] transition-colors duration-500"
              >
                <div className="flex items-center gap-4 mb-5">
                  <span className="inline-flex items-center justify-center w-12 h-12 border border-neutral-200 group-hover:border-[#E97906] group-hover:text-[#E97906] transition-colors">
                    <Icon size={20} />
                  </span>
                  <span className="font-serif-display text-sm tracking-widest text-neutral-400">
                    0{i + 1}
                  </span>
                </div>
                <h3 className="font-serif-display text-2xl lg:text-3xl leading-snug text-neutral-950">
                  {c.title}
                </h3>
                <p className="mt-4 text-[15px] leading-relaxed text-neutral-600 max-w-xl">
                  {c.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
